<template>
  <div class="agree-page">
    <div v-for="(item, index) in detailAgree" :key="index" class="agree-div">
      <ul class="item-ul">
        <li class="first">
          <p class="title">{{item.title}}</p>
        </li>
        <li class="second">
          <div class="right">
            <input type="radio" :name="'select_agree_'+index" class="select-style"
                   v-model="item.agree" :value="true" @change="agreeChange(item)">
            <label class="radio-label pr">동의</label>
            <input type="radio" :name="'select_agree_'+index" class="select-style"
                   v-model="item.agree" :value="false" @change="agreeChange(item)">
            <label class="radio-label">미동의</label>
          </div>
        </li>
        <li class="area">
          <div class="text-area" v-html="item.desc">
          </div>
        </li>
      </ul>
    </div>

    <ul class="footer">
      <li><p>상기 모든 내용 (선택 항목 포함)을 동의하시겠습니까?</p></li>
      <li class="right">
        <input type="radio" name="allAgree" class="select-style"
               v-model="allAgree" :value="true" @change="agreeAllChange">
        <label class="radio-label pr">동의</label>
        <input type="radio" name="allAgree" class="select-style" checked="checked"
               v-model="allAgree" :value="false" @change="agreeAllChange">
        <label class="radio-label">미동의</label>
      </li>
      <li class="button">
        <button class="login-btn" @click="agreeFunc">동의 후 회원가입</button>
      </li>
    </ul>
  </div>
</template>

<script>
import agree from './Join/agree'
export default {
  name: 'JoinAgreeBox',
  data() {
    return {
      detailAgree: [],
      allAgree: null,
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    async init() {
      // 임시
      this.detailAgree = agree;
      Object.entries(this.detailAgree).forEach(([, value]) => {
        value.agree = null;
      })
    },
    agreeChange(item) {
      if(!item.agree) {
        this.allAgree = false;
      }
    },
    agreeAllChange() {
      Object.entries(this.detailAgree).forEach(([, value]) => {
        value.agree = this.allAgree;
      })
    },
    agreeFunc() {
      // 필수 동의 확인
      let agreeCheck = true,
          adMsgAgr = false;
      Object.entries(this.detailAgree).forEach(([, value]) => {
        if(!value.agree && value.required) {
          agreeCheck = value.agree;
        }
        if(value.name === 'adMsgAgree') {
          adMsgAgr = value.agree;
        }
      })

      if(!agreeCheck) {
        alert('필수 동의 사항에 동의해야 회원가입이 가능합니다.');
        return false;
      }

      this.$store.commit('adMsgAgree', adMsgAgr);
      this.$router.push({name: 'citation'});
    }
  }
}
</script>
